import gql from 'graphql-tag';

export const EXPORT_MOBILE_APP_ACCESS = gql`
  query ExportMobileAppAccess($ianaTimeZone: String!, $projectId: String!, $dateFrom: DateTime, $dateTo: DateTime) {
    report {
      exportMobileAppAccess(ianaTimeZone: $ianaTimeZone, projectId: $projectId, dateFrom: $dateFrom, dateTo: $dateTo) {
        contentType
        s3Key
      }
    }
  }
`;
